import { NodeShape } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { PartShape } from '../../BaseShape/PartShape';
import { BaseElement } from '../../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { ValidationResult } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { ValidationResultHelper } from '../../Base/ValidationResultHelper';
import { ValidateHelper } from '../../../../Product/IDE/Util/ValidateHelper';
import { EnumErrorLevel } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumErrorLevel';
import { MDShape } from '../../BaseShape/MDShape';
import { Diagram } from '../Diagram';
import { MDExtendService } from '../../../MD/MDExtendService';
import { Double2D } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/Double2D';
import { MDAConstant } from '../../Base/MDAConstant';
import { EnumPersistenceStatus } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { EnumDisplayLanguage } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/EnumDisplayLanguage';
import { ShapeModel } from '../../BaseShape/ShapeModel';
import { MethodParameter } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/MethodParameter';
import { EntityMethod } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EntityMethod';
import { InterfaceMethod } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/InterfaceMethod';
import { ValueObjectMethod } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/ValueObjectMethod';
import { MDRepository } from '../../../MD/MDRepository';
import { MDValidation } from '../../../MD/MDValidation';

export class JointMethodShape extends PartShape {
  constructor(attributes?: any, opt?: any) {
    super(attributes, opt);
    // this.id = this.curMethod.designId;
    this.set('type', 'mst.JointBaseMethodShape');
    this.attr({
      '.uml-collapse-text': { visibility: 'hidden' },
      '.uml-collapse-rect': { visibility: 'hidden' },
      '.uml-class-container': { rx: 0, ry: 0, opacity: '0.9' }
    });
    // 反序列化调用，手工创建的时候不调用
    if (attributes) {
      this.setMD(attributes?.shape, attributes?.model.element, true);
    }
  }

  public setMD(elementShape: NodeShape, element: InterfaceMethod | EntityMethod | ValueObjectMethod, isFromJSON: boolean) {
    if (element instanceof EntityMethod) {
      MDExtendService.setElementListSequence(element.parameters, true);
    } else if (element instanceof InterfaceMethod) {
      MDExtendService.setElementListSequence(element.parameters, true);
    } else if (element instanceof ValueObjectMethod) {
      MDExtendService.setElementListSequence(element.parameters, true);
    }
    this.setBaseMD(elementShape, this.createModel(element, !elementShape.isExpend), isFromJSON);
  }

  public shapeType(): string {
    return MDAConstant.Type.ADD_METHOD;
  }

  get method(): InterfaceMethod | EntityMethod | ValueObjectMethod {
    if (this.element() instanceof EntityMethod) {
      return this.element() as EntityMethod;
    } else if (this.element() instanceof InterfaceMethod) {
      return this.element() as InterfaceMethod;
    } else {
      return this.element() as ValueObjectMethod;
    }
  }

  doAction(action: string, designId?: string): BaseElement | null {
    let element = super.doAction(action, designId);
    switch (action) {
      // 添加方法项
      case 'shape:addMethodParameter':
        element = this.addMethodParameter();
        break;
      case 'shape:deleteChild':
        element = this.deleteChild(designId);
        break;
      default:
        break;
    }
    this.refresh();
    return element;
  }

  /** 根据链接的类型，设置鼠标的样式 */
  setLinkType(linkType: string) {
    if (linkType !== '') {
      this.attr({ '.uml-class-container': { cursor: 'not-allowed' }, '.uml-class-name-text': { cursor: 'not-allowed' } });
    } else {
      this.attr({ '.uml-class-container': { cursor: 'move' }, '.uml-class-name-text': { cursor: 'move' } });
    }
  }

  protected getDisplayTitle(element: BaseElement) {
    let title = element.displayName;
    if (element instanceof MethodParameter) {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = `${element.name}:${this.getDataType(element.dataType, element.referenceType)}`;
      } else {
        title = `${element.displayName}:${this.getDataType(element.dataType, element.referenceType)}`;
      }
    } else {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = element.name;
      } else {
        title = element.displayName;
      }
    }
    return title;
  }

  private addMethodParameter(): MethodParameter {
    const item = MDRepository.createMethodParameter(this.method);
    MDExtendService.setElementListSequence(this.method.parameters, true);
    this.model().compartments[0].push(item);
    return item;
  }

  /** 删除子元素及对应的行 */
  private deleteChild(designId: string): BaseElement | null {
    let element: BaseElement = null;
    element = this.method.parameters.find(item => item.designId === designId);
    if (element) {
      // 新建状态的，需要从元数据中删除
      if (element.persistenceStatus === EnumPersistenceStatus.Create) {
        this.method.parameters.splice(this.method.parameters.findIndex(item => item.designId === element.designId), 1);
      } else {
        element.persistenceStatus = EnumPersistenceStatus.Delete;
      }
      return this.deleteRow(designId);
    }
    return null;
  }

  /** 设置图形的Model */
  private createModel(method: InterfaceMethod | EntityMethod | ValueObjectMethod, isCollapse = false): ShapeModel {
    const model = new ShapeModel(method, isCollapse);
    model.addCompartment(method.parameters.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete));
    return model;
  }

  /**
   * 克隆图形，包括图形内部所有元素，不包括与其他图形的关系
   * @param diagram 克隆后所属的图表
   * @param elements 克隆的所有元数据都插入数组返回
   */
  public cloneShape(diagram: Diagram, elements: Array<BaseElement>): MDShape {
    const jShape = new JointMethodShape();

    const newShape = new NodeShape();
    newShape.copyFrom(this.shape(), false);
    MDExtendService.setCreateInfo(newShape);
    newShape.startPoint = new Double2D(this.position().x + 20, this.position().y + 20);
    newShape.diagram_ID = diagram.diagramShape.id;
    diagram.diagramShape.nodeShapes.push(newShape);

    let newElement: InterfaceMethod | EntityMethod | ValueObjectMethod = null;
    if (this.method instanceof InterfaceMethod) {
      newElement = new InterfaceMethod();
      newElement.copyFrom(this.method, false);
      newElement.interface_ID = this.method.interface_ID;
      this.method.interface.methods.push(newElement);
    } else if (this.method instanceof EntityMethod) {
      newElement = new EntityMethod();
      newElement.copyFrom(this.method, false);
      newElement.entity_ID = this.method.entity_ID;
      this.method.entity.methods.push(newElement);
    } else if (this.method instanceof ValueObjectMethod) {
      newElement = new ValueObjectMethod();
      newElement.copyFrom(this.method, false);
      newElement.valueObject_ID = this.method.valueObject_ID;
      this.method.valueObject.methods.push(newElement);
    }
    MDExtendService.setCreateInfo(newElement);
    elements.push(newElement);

    this.method.parameters.forEach(item => {
      const parameter = new MethodParameter();
      parameter.copyFrom(item, false);
      MDExtendService.setCreateInfo(parameter);
      if (this.method instanceof InterfaceMethod) {
        parameter.interfaceMethod_ID = newElement.id;
      } else if (this.method instanceof EntityMethod) {
        parameter.entityMethod_ID = newElement.id;
      } else if (this.method instanceof ValueObjectMethod) {
        parameter.valueObjectMethod_ID = newElement.id;
      }
      newElement.parameters.push(parameter);
      elements.push(parameter);
    });

    newShape.elementId = newElement.designId;
    jShape.setMD(newShape, newElement, false);
    diagram.cells.push(jShape);
    return jShape;
  }

  public addChildClone(element: BaseElement, elements: Array<BaseElement>): MethodParameter | null {
    let newElement: MethodParameter | null = null;
    if (element instanceof MethodParameter) {
      newElement = new MethodParameter();
      newElement.copyFrom(element, false);
      MDExtendService.setCreateInfo(newElement);
      if (this.method instanceof InterfaceMethod) {
        newElement.interfaceMethod_ID = this.method.id;
      } else if (this.method instanceof EntityMethod) {
        newElement.entityMethod_ID = this.method.id;
      } else if (this.method instanceof ValueObjectMethod) {
        newElement.valueObjectMethod_ID = this.method.id;
      }
      newElement.interfaceMethod_ID = this.method.id;
      this.method.parameters.push(newElement);
      elements.push(newElement);
    }
    return newElement;
  }

  /** 校验模型 */
  public validate(): Array<ValidationResult> {
    const errors = super.validate();
    const containerDesignId = this.method.designId;
    MDValidation.validateBaseElement(this.method, this.method.designId, true, errors);
    if (this.method.parameters.length > 0) {
      this.method.parameters.forEach(element => {
        MDValidation.validateBaseElement(element, element.designId, false, errors);
        if (!ValidateHelper.IsNotNullOrEmpty(element.name)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `方法 [${this.method.displayName}] 的参数必须填写名称`));
        }
        if (!ValidateHelper.IsNotNullOrEmpty(element.displayName)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `方法 [${this.method.displayName}] 的参数必须填写显示名称`));
        }
        if (this.method.parameters.find(item => element.designId !== item.designId && element.name === item.name)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `方法 [${this.method.displayName}] 存在同名参数 [${element.name}]`));
        }
      });
    }
    return errors;
  }
}
